/** Primary hero CTA resolved from the admin-configured slide content (analysis §6 S23, allowed content). */
export interface HeroCta {
  /** Admin button title; `null` means the default translated label (`home.startNow`). */
  label: string | null;
  /** Internal path for `routerLink`; `null` when the target is external. */
  internal: string | null;
  /** Absolute http(s) URL opened in a new tab; `null` when the target is internal. */
  external: string | null;
}

export const DEFAULT_HERO_CTA_PATH = '/course';

/**
 * Label = `buttonTitle` when non-empty. Target = `link` when non-empty: an absolute http(s) URL is external,
 * any other value (an app path) is internal; an empty link, or one with another scheme (e.g. `javascript:`)
 * or protocol-relative form, falls back to `/course`.
 */
export function resolveHeroCta(item: { buttonTitle?: string | null; link?: string | null } | null | undefined): HeroCta {
  const label = item?.buttonTitle?.trim() || null;
  const link = item?.link?.trim() || '';

  if (/^https?:\/\//i.test(link)) return { label, internal: null, external: link };

  const isApplicationPath = !!link && !link.startsWith('//') && !/^[a-z][a-z0-9+.-]*:/i.test(link);
  if (isApplicationPath) return { label, internal: link.startsWith('/') ? link : `/${link}`, external: null };

  return { label, internal: DEFAULT_HERO_CTA_PATH, external: null };
}
